import type { IAppLogger, LogLevel } from '../../domain/ports/IAppLogger';

export class ConsoleAppLogger implements IAppLogger {
  log(level: LogLevel, message: string, context?: Record<string, unknown>): void {
    const payload = context ? ` ${JSON.stringify(context)}` : '';
    const line = `[${level}] ${message}${payload}`;
    switch (level) {
      case 'error':
        console.error(line);
        break;
      case 'warn':
        console.warn(line);
        break;
      default:
        console.log(line);
    }
  }
}